import ReactDOM from 'react-dom'; // Wrapper around react-dom to handle incompatabilities between versions 16 and 18

var majorVersion = ReactDOM.version.split('.')[0];
var ReactDomAdapter = {
  render: function render(component, nodeContainer) {
    // const root = createRoot(nodeContainer);
    if (majorVersion === '18') {
      var root = ReactDOM.createRoot(nodeContainer);
      root.render(component);
    } else {
      ReactDOM.render(component, nodeContainer);
    }
  },
  unmount: function unmount(nodeContainer) {
    if (majorVersion === '18') {
      var root = ReactDOM.createRoot(nodeContainer);
      root.unmount();
    } else {
      ReactDOM.unmountComponentAtNode(nodeContainer);
    }
  }
};
export default ReactDomAdapter;